var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1-1h582v402h-582z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#c5c5c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.344974 7.894318c.74123-3.55015 3.96964-6.22222 7.83997-6.22222s7.09874 2.67207 7.83997 6.22222c-.74123 3.55015-3.96964 6.22222-7.83997 6.22222s-7.09874-2.67207-7.83997-6.22222z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.184944,
    cy: 7.894318,
    rx: 2.4,
    ry: 2.333333
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayIcon);
export default __webpack_public_path__ + "static/media/display_icon.ab318c28b803e32605bb8e2126919e9c.svg";
export { ForwardRef as ReactComponent };